<template>
  <div id="contentWrap" class="crpg-t-resort-stay clear">
    <OrganismsPrivateResortStayContent />
  </div>
</template>

<script>
import OrganismsPrivateResortStayContent from "@/components/organisms/resortStay/ResortStayContent.vue";

export default {
  name: "TemplatesPrivateResortStay",
  components: {
    OrganismsPrivateResortStayContent,
  },
};
</script>
